import { render, staticRenderFns } from "./addClient.vue?vue&type=template&id=69a2019c&scoped=true&"
import script from "./addClient.vue?vue&type=script&lang=js&"
export * from "./addClient.vue?vue&type=script&lang=js&"
import style0 from "./addClient.vue?vue&type=style&index=0&id=69a2019c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a2019c",
  null
  
)

export default component.exports